export default {
  DOC_ID: 1,
  HEART_ID: 2,
  ORDER_MENU_ID: 1,
  COLLECTION_MENU_ID: 2,
  INVITATION_AND_EXCHANGE_ID: 3,
  DEFAULT_NATION_CODE: 86,
  DRAFT_TYPE: {
    speech: 0,
    wanxiang: 1,
    record: 2,
  },
  COLLECTION_TYPE: {
    0: { label: '演讲', type: 'speech' },
    2: { label: '枝桠视频', type: 'zhiya' },
    4: { label: '记录', type: 'record' },
    7: { label: '万象视频', type: 'wanxiang' },
  },
};
